import React, { useEffect, useState, useRef, Suspense} from 'react';
import { useNavigate } from 'react-router';
import { getCookieValue, postToNativeApp } from '../common/helpers';
import { beneficiariesAsync, getBeneficiaries } from '../reducers/beneficiaries.slice';
import {  useAppDispatch, useAppSelector } from "../app/hooks";
import { Insurer } from '../interfaces/beneficiaries.interface';
import { useSearchParams } from 'react-router-dom';
import { dataLayerPush } from '../utils/gtm';
import Constants from '../constants/Constants';
import { getConfig } from '../reducers/config.slice';
import { postRequest, postRequestHospital } from '../app/postRequest.service';
import { HOSPITAL_DETAILS, INSURER_MASTER_URL, NETWORK_HOSPITAL_URL, SPECIALITY_MASTER_URL } from '../common/common.constants';
import  "@mediassistrepo/network-hospitals/dist/root.css";
import Loader from './shared/Loader';
interface NetworkHospitalProps {
  insurerList: any[];
  lat: string | null;
  long: string | null;
  source: string | null;
  getHospitalApi: (requestJSON: any) => Promise<any>;
  getSpeciality: (requestOptions: any) => Promise<any>;
  getInsurer: (requestOptions: any) => Promise<any>;
  getExcludedHospital: () => Promise<any>;
  getHospitalDetails: (requestJSON: any) => Promise<any>;
  accessToken: string | null;
  handleBackClick: () => void;
  handleChange: (value: string) => void;
  handleClickOnCard: (value: any, value1: any) => void;
  hideIntimation: boolean;
}
interface IProps {
    API_KEY: string;
    BENEFICIARY: string;
    INSURER: string;
}

const NetworkHosptal = React.lazy(async () => {
  const module = await import("@mediassistrepo/network-hospitals");
  return {
    default: module.NetworkHosptal as React.ComponentType<NetworkHospitalProps>
  };
});
export default function NetworkHospital () {
    const navigate = useNavigate();
    const [networkData, setNetworkData] = React.useState(null);
    const beneficiariesResponse = useAppSelector(getBeneficiaries);
    const [searchParams] = useSearchParams();
    const source = searchParams.get('source');
    const dispatch = useAppDispatch();
    const corporateConfig = useAppSelector(getConfig);

    useEffect(() => {
        if (localStorage.getItem('platform') == 'android' && localStorage.getItem('lat') && localStorage.getItem('long')) { //take lat and long from medibuddy app 
            setNetworkData({ lat: localStorage.getItem('lat'), long: localStorage.getItem('long') })
        }
        if (getCookieValue("platform") == "ios") {
            window.addEventListener("message", handleMessage);
            return () => {
                window.removeEventListener("message", handleMessage);
            };
        } else if (getCookieValue("platform") == "android") {
            document.addEventListener("message", handleMessage);
            return () => {
                document.removeEventListener("message", handleMessage);
            };
        }
    }, []);
  
    useEffect(() => {
        if(!beneficiariesResponse){
        dispatch(beneficiariesAsync());
      }
    },[]);
  
    useEffect(() => {
      const insurerSet = new Set<number>();
      const insurerList = Array<Insurer>();
      beneficiariesResponse?.policyDetails.forEach((policyDetail:any) => {
        if (!insurerSet.has(policyDetail.policyInsCompId)) {
          const insurer = new Insurer();
          insurer.name = policyDetail.insuranceCompanyName;
          insurer.shortName = policyDetail.insuranceCompanyShortName;
          insurerList.push(insurer);
          insurerSet.add(policyDetail.policyInsCompId);
        }
      });
        if(insurerList?.length){
          sessionStorage.setItem(Constants.Instance.INSURER_LIST,JSON.stringify(insurerList));
      }
    }, [beneficiariesResponse]);
  
    const handleMessage = (event: any) => {
      const message = JSON.parse(event?.data);
      if (message.event === 'networkHospitalClick') {
            const messageRecieved = JSON.parse(message?.data);
            setNetworkData(messageRecieved)
      }
    };
  
    const initializeNetwokComp = () =>{
      navigate('/')
    }
  
    useEffect(() => {
      if (getCookieValue('source') == 'native') {
        postToNativeApp({ "location": "getAndroidlocation" })
      }
    }, [])
  
    const getHospitalApi = async (requestJSON: any) => {
      try{
        const response: any = await postRequestHospital(NETWORK_HOSPITAL_URL, requestJSON);
        return response
      } catch(error){
        throw error; 
      }
    };

    const getSpeciality = async (requestOptions: any) => {
      let url=SPECIALITY_MASTER_URL
      try {
        const response: any = await postRequest(url, requestOptions);
        return response;
      } catch(error){
        throw error; 
      }
    }
    const getInsurer = async (requestOptions: any) => {
      let url=process.env.REACT_APP_NETWORK_HOSPITAL_URL+INSURER_MASTER_URL
      try{ 
        const response: any = await fetch(url, requestOptions);
        return response;
        }catch(error){
          throw error; 
      }
    };
    const getExcludedHospital = async () => {
      let url=process.env.REACT_APP_API_INSURER;
      try{ 
        const response: any = await fetch(url);
        return response;
      } catch(error){
        throw error; 
      }
    };
    
    const getHospitalDetails = async (requestJSON: any) => {
      try{
        const response: any = await postRequestHospital(HOSPITAL_DETAILS, requestJSON);
        return response
      } catch(error){
        throw error; 
      }
    };

    return (
      <>
        <Suspense fallback={<Loader/>}>
        <NetworkHosptal
          insurerList={JSON.parse(sessionStorage.getItem(Constants.Instance.INSURER_LIST)) ?? []}
          lat={networkData?.lat}
          long={networkData?.long}
          source={localStorage.getItem(Constants.Instance.SOURCE)}
          getHospitalApi={getHospitalApi}
          getSpeciality={getSpeciality}
          getInsurer={getInsurer}
          getExcludedHospital={getExcludedHospital}
          getHospitalDetails={getHospitalDetails}
          accessToken={localStorage.getItem(Constants.Instance.ACCESS_TOKEN)}
          handleBackClick={initializeNetwokComp}
          handleChange={(value:any)=>{
            dataLayerPush(Constants.Instance.HOSPITAL_SEARCH, {
              keyword: value
            });
          }}
          handleClickOnCard={(value: any,value1:any)=>{
            dataLayerPush(Constants.Instance.NETWORK_HOSPITAL_CTA_INTERACTION, {
              cta_text:value,
              section_name: value1  
            }); 
          }}
          hideIntimation={corporateConfig?.hideIntimation}
        /> 
        </Suspense>
      </>
    )
}
